import React, { useEffect, useState } from 'react'
import { ReactComponent as LeftOlive } from 'components/ContentBox/img/left_olive.svg'
import { ReactComponent as RightOlive } from 'components/ContentBox/img/right_olive.svg'
import styles from './MainTableRowScore.module.scss'
import { observer } from 'mobx-react'

function MainTableRowScore(props) {
  const [data, setData] = useState({
    stats: {
      points: 0,
      incorrect_answers: 0,
      correct_answers: 0,
      total_answers: 0,
      total_points: 0,
    },
  })

  useEffect(() => {
    if (props?.stats) {
      const stats = {
        ...props.stats,
        points: props.stats.points + (props?.employeePoints || 0),
      }

      setData({ stats })
    }
  }, [props?.stats, props?.employeePoints])

  let studentPoints =
    isNaN(data?.stats?.points) || data?.stats?.points === null
      ? 0
      : data?.stats?.points

  let maximumPoints =
    isNaN(data?.stats?.total_points) || data?.stats?.total_points === null
      ? 0
      : data?.stats?.total_points

  let percentage =
    maximumPoints === 0
      ? 0
      : Math.min(100, Math.round((studentPoints / maximumPoints) * 100))

  return (
    <div className={styles.mainTableRowScore}>
      <LeftOlive />
      <div className={styles.bigNumbers}>
        <div className={styles.largeNumber}>
          {data?.stats?.correct_answers || 0}
        </div>
        <div className={styles.secondaryNumber}>{`${percentage}%`}</div>
      </div>
      <RightOlive />
      <div className={styles.scoreInfo}>
        <div className={styles.questionInfo}>
          Questions:
          <span className={styles.fontWeightNumbers}>
            {data?.stats?.correct_answers || 0}
          </span>
          <span className={styles.verticalLine}>|</span>
          <span className={styles.numbers}>
            {data?.stats?.total_answers || 0}
          </span>
        </div>
        <div className={styles.scoreNumbers}>
          Score:
          <span className={styles.fontWeightNumbers}>
            {data?.stats?.points || 0}
          </span>
          <span className={styles.verticalLine}>|</span>
          <span className={styles.numbers}>
            {data?.stats?.total_points || 0}
          </span>
          <span className={styles.verticalLine}>|</span>
          <span className={styles.percentNumbers}>{`${percentage}%`}</span>
        </div>
      </div>
    </div>
  )
}

export default observer(MainTableRowScore)
